// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { songbirdTestnet as _songbirdTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the songbirdTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 16
 * Chain Name: Coston
 * Default Block Explorer: https://coston-explorer.flare.network
 * Default RPC URL: https://coston-api.flare.network/ext/C/rpc
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { songbirdTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: songbirdTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const songbirdTestnet = createCommon({
	..._songbirdTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
